import {Injectable} from "@angular/core";
import {CompositeFormService} from "../../../../umbrella-common/services/composite-form.service";
import {CompanyAddressBillingFormService} from "../../company-address/company-address-billing-form-service";
import {ContactPersonBillingFormService} from "../../contact-person/contact-person-billing.form.service";
import {BillingInformation, Order} from "../../../../store/state/order.state";
import {deepCopy} from "../../../../umbrella-common/common-functions";
import {BaseOrderFormService} from "../../common/base-order-form.service";
import {BillingPreferencesFomService} from "./billing-preferences/billing-preferences-fom.service";

@Injectable()
export class BillingInfoFormService extends CompositeFormService {

	constructor(billingPreferencesFS: BillingPreferencesFomService, companyAddressFS: CompanyAddressBillingFormService, contactPersonFS: ContactPersonBillingFormService) {
		super([billingPreferencesFS, companyAddressFS, contactPersonFS]);
	}

	getBillingInformationFor(order: Order): BillingInformation {
		let o = deepCopy(order) as Order;
		this.allFormServices.filter(fs => fs.isFormInitialized()).forEach(fs => (fs as unknown as BaseOrderFormService).fillOrder(o));
		return o.billingInformations;
	}
}
